import Shape from './shape'
import TooltipContent from './tooltip-content'
import TooltipCursor from './tooltip-cursor'
import Legends from './legends'


export {
    Shape as BenchmarkShape,
    TooltipContent as BenchmarkTooltipContent,
    TooltipCursor as BenchmarkTooltipCursor,
    Legends as BenchmarkLegends,
}


// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/benchmark/benchmark.js